import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Of London, Murphy and Seedcamp",
  "description": "",
  "published": "2009-09-14T00:00:00.000Z",
  "redirect_from": ["/blog/of-london-murphy-and-seedcamp/swizec/718"],
  "categories": "Business, life, Linear algebra, London, Seedcamp, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:442px_-_London_Lead_Image.jpg"
          }}><img parentName="a" {...{
              "src": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/442px_-_London_Lead_Image.jpg/300px-442px_-_London_Lead_Image.jpg",
              "alt": "Greater London",
              "title": "Greater London"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:442px_-_London_Lead_Image.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Last week's trip to `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/London",
        "title": "London"
      }}>{`London`}</a>{` was governed by the laws of Murphy, or Sod as Londoners would call 'im. It was a fun and interesting trip, don't get me wrong, and I still love London almost as much as I did after my last trip there two years ago. It's just that pretty much everything imaginable that could go wrong actually done gone wrong and the culmination of this was that we didn't advance to `}<a parentName="p" {...{
        "href": "http://www.seedcamp.com",
        "title": "Seedcamp"
      }}>{`Seedcamp`}</a>{` week.`}</p>
    <p>{`But let me start from the beginning. Day one went great, we finished the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Linear_algebra",
        "title": "Linear algebra"
      }}>{`linear algebra`}</a>{` exam (flunked it yet again btw) and set of to Munich for the flight. The ride went spectacularly smooth and we got to our flight on time. And that's when the trouble started.`}</p>
    <p>{`During the day I got some more ideas on how to polish our presentation and decided to do them at the airport. There wasn't enough time. Alright, I'll do them on the aeorplane. Oh crap, aeroplanes don't have internets, no go. Very well, can't do the presentation, can't do the polishing on the demo. Fine.`}</p>
    <p>{`So then we got to `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/London_Gatwick_Airport",
        "title": "London Gatwick Airport"
      }}>{`Gatwick`}</a>{` and paid through the nose to get to `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/London_Victoria_station",
        "title": "London Victoria station"
      }}>{`Victoria station`}</a>{`. Now what? Well after a brief search for somewhere to stay, we took a ride off to Pimlico where the fucking shoebox was ready to take us in. It was a twin bed`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      